import { createRouter, createWebHashHistory } from 'vue-router';
import { useMemberStore } from '../stores';
import axios from 'axios';
import MainVue from '../views/Main.vue';
import LoginVue from '../views/Login.vue';
import JsjOrderJjVue from '../views/jsj/JsjOrderJj.vue';
import JsjOrderAddVue from '../views/order/jsjOrderAdd.vue';
import JsjOrderListVue from '../views/order/jsjOrderList.vue';
//新订单查询
import OrdersVue from '../views/order/orders.vue';
import SjInfoListVue from '../views/sj/sjInfoList.vue';
import SjddListVue from '../views/sj/sjddList.vue';
import SjInfoAddVue from '../views/sj/sjInfoAdd.vue';
import CarCalendarVue from '../views/cl/carCalendar.vue';
import CarCalendarListVue from '../views/cl/carCalendarList.vue';
import ClInfoListVue from '../views/cl/clInfoList.vue';
import ClInfoAddVue from '../views/cl/clInfoAdd.vue';
import CxInfoListVue from '../views/cl/cxInfoList.vue';
import CxInfoAddVue from '../views/cl/cxInfoAdd.vue';
import KfInfoAddVue from '../views/kf/kfInfoAdd.vue';
import KfInfoListVue from '../views/kf/kfInfoList.vue';
import UserAddVue from '../views/hrm/userAdd.vue';
import UserListVue from '../views/hrm/userList.vue';
import DepartmentTreeVue from '../views/hrm/departmentTree.vue';
import IntegralApplyVue from '../views/integral/apply.vue';
import IntegralApplyListVue from '../views/integral/applyList.vue';
import GmapVue from '../views/gmap.vue';
import YhqInfoAddVue from '../views/yhq/yhqInfoAdd.vue';
import YhqInfoListVue from '../views/yhq/yhqInfoList.vue';
import YhqGrantListVue from '../views/yhq/yhqGrantList.vue';
import RegisterSjListVue from '../views/sj/registerSjList.vue';
import RegisterSjPassListVue from '../views/sj/registerSjPassList.vue';
import RegisterSjNoPassListVue from '../views/sj/registerSjNoPassList.vue';
import GoodInfoAddVue from '../views/mall/goodInfoAdd.vue';
import GoodInfoListVue from '../views/mall/goodInfoList.vue';
import HotelOrderListVue from '../views/mall/hotelOrderList.vue';
import ConsultListVue from '../views/consult/consultList.vue';
import ConsultInfoListVue from '../views/consult/consultInfoList.vue';
import DynamicFlightVue from '../views/dynamicFlight/index.vue';
import HospitalInfoVue from '../views/medicalView/hospitals/hospitalInfo.vue';
import HospitalInfoAddVue from '../views/medicalView/hospitals/hospitalInfoAdd.vue';
import HospitalInfoListVue from '../views/medicalView/hospitals/hospitalInfoList.vue';
import SpaInfoVue from '../views/medicalView/spa/spaInfo.vue';
import SpaInfoAddVue from '../views/medicalView/spa/spaInfoAdd.vue';
import SpaInfoListVue from '../views/medicalView/spa/spaInfoList.vue';
import SceneInfoVue from '../views/medicalView/scenes/sceneInfo.vue';
import SceneInfoAddVue from '../views/medicalView/scenes/sceneInfoAdd.vue';
import SceneInfoListVue from '../views/medicalView/scenes/sceneInfoList.vue';
import RestaurantInfoVue from '../views/medicalView/restaurant/restaurantInfo.vue';
import RestaurantInfoAddVue from '../views/medicalView/restaurant/restaurantInfoAdd.vue';
import RestaurantInfoListVue from '../views/medicalView/restaurant/restaurantInfoList.vue';
import DoctorInfoVue from '../views/medicalView/doctor/doctorInfo.vue';
import DoctorInfoAddVue from '../views/medicalView/doctor/doctorInfoAdd.vue';
import DoctorInfoListVue from '../views/medicalView/doctor/doctorInfoList.vue';
import NewsInfoVue from '../views/medicalView/news/newsInfo.vue';
import NewsInfoAddVue from '../views/medicalView/news/newsInfoAdd.vue';
import NewsInfoListVue from '../views/medicalView/news/newsInfoList.vue';
import CommentInfoListVue from '../views/medicalView/comments/commentInfoList.vue'
import DictionaryAddVue from '../views/medicalView/dictionary/dictionaryAdd.vue';
import DictionaryListVue from '../views/medicalView/dictionary/dictionaryList.vue';
import KlookCarListVue from '../views/klook/carInfoList.vue';
import KlookDriverListVue from '../views/klook/driverInfoList.vue';
import KlookOrdersListVue from '../views/klook/ordersInfoList.vue';

//航班信息展示
import FlightInfoBoardVue from '../views/FlightInfoBoard.vue';

const routes = [
	{
		path: '/index', 
        component: MainVue,
        meta: { 
			requiresAuth: true,
			title:'首页'
		},
		children: [
		    {
		        path: 'jsj-jj-order',
		        component: JsjOrderJjVue,
				meta: { 
					requiresAuth: true ,
					title:'接机订单'
				},
		    },
		    {
		        path: 'jsj-order-add',
		        component: JsjOrderAddVue,
				meta: { 
					requiresAuth: true,
					title:'订单录入' ,
				},
		    },
			{
			    path: 'jsj-order-list',
			    component: JsjOrderListVue,
				meta: { 
					requiresAuth: true,
					title:'录入订单信息' ,
				},
			},
			{
			    path: 'orders-list',
			    component: OrdersVue,
				meta: { 
					requiresAuth: true,
					title:'订单查询-新' ,
				},
			}
		],
	},
    { 
		path: '/', 
		redirect: '/index',
		meta: { 
			requiresAuth: true ,
			title:'首页' ,
		},
	},
	{ 
		path: '/login', 
		component: LoginVue,
		meta: { 
			requiresAuth: false,
			title:'登录' ,
		},
	},
	{
		path: '/flightInfoBoard', 
		component: FlightInfoBoardVue,
		meta: { 
			requiresAuth: false,
			title:'航班信息' ,
		},
	},
	{
		path: '/dynamicFlight', 
		component: DynamicFlightVue,
		meta: { 
			requiresAuth: false,
			title:'航班动态' ,
		},
	},
	{
		path: '/driver', 
		component: MainVue,
		meta: { 
			requiresAuth: true,
			title:'司机管理'
		},
		children: [
		    {
		        path: 'driver-add',
		        component: SjInfoAddVue,
				meta: { 
					requiresAuth: true ,
					title:'司机新增'
				},
		    },
		    {
		        path: 'driver-manage',
		        component: SjInfoListVue,
				meta: { 
					requiresAuth: true,
					title:'司机查询' ,
				},
		    },
			{
			    path: 'driver-order',
			    component: SjddListVue,
				meta: { 
					requiresAuth: true,
					title:'司机订单' ,
				},
			}
		]
	},
	{
		path: '/car', 
		component: MainVue,
		meta: { 
			requiresAuth: true,
			title:'车辆管理'
		},
		children: [
			{
			    path: 'cate-add',
			    component: CxInfoAddVue,
				meta: { 
					requiresAuth: true ,
					title:'车型分类新增'
				},
			},
			{
			    path: 'cate-manage',
			    component: CxInfoListVue,
				meta: { 
					requiresAuth: true ,
					title:'车型分类管理'
				},
			},
		    {
		        path: 'car-add',
		        component: ClInfoAddVue,
				meta: { 
					requiresAuth: true ,
					title:'车辆类型新增'
				},
		    },
		    {
		        path: 'car-manage',
		        component: ClInfoListVue,
				meta: { 
					requiresAuth: true,
					title:'车辆类型管理' ,
				},
		    },
		    {
		        path: 'car-calendar-add',
		        component: CarCalendarVue,
				meta: { 
					requiresAuth: true,
					title:'车辆日历新增' ,
				}, 
		    },
		    {
		        path: 'car-calendar-list',
		        component: CarCalendarListVue,
				meta: { 
					requiresAuth: true,
					title:'车辆日历查询' ,
				},
		    },
		]
	},
	{
		path: '/kf', 
		component: MainVue,
		meta: { 
			requiresAuth: true,
			title:'客服管理'
		},
		children: [
		    {
		        path: 'kf-add',
		        component: KfInfoAddVue,
				meta: { 
					requiresAuth: true ,
					title:'车辆客服'
				},
		    },
		    {
		        path: 'kf-manage',
		        component: KfInfoListVue,
				meta: { 
					requiresAuth: true,
					title:'查询客服' ,
				},
		    },
			{
			    path: 'gmap',
			    component: GmapVue,
				meta: { 
					requiresAuth: true,
					title:'地图' ,
				},
			},
		]
	},
	{
		path: '/integral', 
		component: MainVue,
		meta: { 
			requiresAuth: true,
			title:'积分申请管理'
		},
		children: [
		    {
		        path: 'apply-add',
		        component: IntegralApplyVue,
				meta: { 
					requiresAuth: true ,
					title:'新建申请'
				},
		    },
		    {
		        path: 'apply-manage',
		        component: IntegralApplyListVue,
				meta: { 
					requiresAuth: true,
					title:'申请查询' ,
				},
		    }
		]
	},{
		path: '/coupon', 
		component: MainVue,
		meta: { 
			requiresAuth: true,
			title:'优惠券管理'
		},
		children: [
		    {
		        path: 'coupon-add',
		        component: YhqInfoAddVue,
				meta: { 
					requiresAuth: true ,
					title:'新增优惠券'
				},
		    },
		    {
		        path: 'coupon-manage',
		        component: YhqInfoListVue,
				meta: { 
					requiresAuth: true,
					title:'查看优惠券' ,
				},
		    },
		    {
		        path: 'coupon-granted',
		        component: YhqGrantListVue,
				meta: { 
					requiresAuth: true,
					title:'已发放优惠券' ,
				},
		    }
		]
	},
	{
		path: '/dregister', 
		component: MainVue,
		meta: { 
			requiresAuth: true,
			title:'司机注册审核'
		},
		children: [
		    {
		        path: 'register-todo',
		        component: RegisterSjListVue,
				meta: { 
					requiresAuth: true ,
					title:'待审核'
				},
		    },
			{
			    path: 'register-pass',
			    component: RegisterSjPassListVue,
				meta: { 
					requiresAuth: true ,
					title:'审核通过'
				},
			},
			{
			    path: 'register-nopass',
			    component: RegisterSjNoPassListVue,
				meta: { 
					requiresAuth: true ,
					title:'审核退回'
				},
			}
		]
	},
	{
		path: '/mall', 
		component: MainVue,
		meta: { 
			requiresAuth: true,
			title:'酒店管理'
		},
		children: [
		    {
		        path: 'good-add',
		        component: GoodInfoAddVue,
				meta: { 
					requiresAuth: true ,
					title:'房间新增'
				},
		    },
			{
			    path: 'good-list',
			    component: GoodInfoListVue,
				meta: { 
					requiresAuth: true ,
					title:'房间查询'
				},
			},
			{
			    path: 'good-orders-list',
			    component: HotelOrderListVue,
				meta: { 
					requiresAuth: true ,
					title:'酒店订单'
				},
			}
		]
	},
	{
		path: '/consult', 
		component: MainVue,
		meta: { 
			requiresAuth: true,
			title:'咨询管理'
		},
		children: [
		    {
		        path: 'consult-list',
		        component: ConsultListVue,
				meta: { 
					requiresAuth: true ,
					title:'咨询机构'
				},
		    },
			{
			    path: 'consult-info-list',
			    component: ConsultInfoListVue,
				meta: { 
					requiresAuth: true ,
					title:'咨询人员'
				},
			}
		]
	},
	{
		path: '/klook', 
		component: MainVue,
		meta: { 
			requiresAuth: true,
			title:'Klook管理'
		},
		children: [
		    {
		        path: 'car-list',
		        component: KlookCarListVue,
				meta: { 
					requiresAuth: true ,
					title:'车辆管理'
				},
		    },
			{
			    path: 'driver-list',
			    component: KlookDriverListVue,
				meta: { 
					requiresAuth: true ,
					title:'司机管理'
				},
			},
			{
			    path: 'orders-list',
			    component: KlookOrdersListVue,
				meta: { 
					requiresAuth: true ,
					title:'订单管理'
				},
			}
		]
	},
	{
		path: '/hrm', 
		component: MainVue,
		meta: { 
			requiresAuth: true,
			title:'用户管理'
		},
		children: [
		    {
		        path: 'user-add',
		        component: UserAddVue,
				meta: { 
					requiresAuth: true ,
					title:'添加用户'
				},
		    },
			{
			    path: 'user-list',
			    component: UserListVue,
				meta: { 
					requiresAuth: true ,
					title:'用户列表'
				},
			},
			{
			    path: 'department-tree',
			    component: DepartmentTreeVue,
				meta: { 
					requiresAuth: true ,
					title:'组织结构'
				},
			}
		]
	},
	{
		path: '/medical', 
		component: MainVue,
		meta: { 
			requiresAuth: true,
			title:'医美管理'
		},
		children: [
		    {
		        path: 'hospital-add',
		        component: HospitalInfoAddVue,
				meta: { 
					requiresAuth: true ,
					title:'新增诊所'
				},
		    },
			{
			    path: 'hospital-list',
			    component: HospitalInfoListVue,
				meta: { 
					requiresAuth: true ,
					title:'诊所列表'
				},
			}
		]
	},
	{
		path: '/medical/hospital-info', 
		component: HospitalInfoVue,
		meta: { 
			requiresAuth: true,
			title:'诊所详情'
		},
		children: [
		]
	},
	{
		path: '/medical/spa-info', 
		component: SpaInfoVue,
		meta: { 
			requiresAuth: true,
			title:'SPA详情'
		},
		children: [
		]
	},
	{
		path: '/medical/restaurant-info', 
		component: RestaurantInfoVue,
		meta: { 
			requiresAuth: true,
			title:'餐厅详情'
		},
		children: [
		]
	},
	{
		path: '/medical/doctor-info', 
		component: DoctorInfoVue,
		meta: { 
			requiresAuth: true,
			title:'医师详情'
		},
		children: [
		]
	},
	{
		path: '/medical/news-info', 
		component: NewsInfoVue,
		meta: { 
			requiresAuth: true,
			title:'资讯详情'
		},
		children: [
		]
	},
	{
		path: '/medical/scene-info', 
		component: SceneInfoVue,
		meta: { 
			requiresAuth: true,
			title:'景点详情'
		},
		children: [
		]
	},
	{
		path: '/spa-info', 
		component: MainVue,
		meta: { 
			requiresAuth: true,
			title:'SPA管理'
		},
		children: [
		    {
		        path: 'spa-add',
		        component: SpaInfoAddVue,
				meta: { 
					requiresAuth: true ,
					title:'新增SPA'
				},
		    },
			{
			    path: 'spa-list',
			    component: SpaInfoListVue,
				meta: { 
					requiresAuth: true ,
					title:'SPA列表'
				},
			}
		]
	},
	{
		path: '/scene-info', 
		component: MainVue,
		meta: { 
			requiresAuth: true,
			title:'景点管理'
		},
		children: [
		    {
		        path: 'scene-add',
		        component: SceneInfoAddVue,
				meta: { 
					requiresAuth: true ,
					title:'新增热门景点'
				},
		    },
			{
			    path: 'scene-list',
			    component: SceneInfoListVue,
				meta: { 
					requiresAuth: true ,
					title:'热门景点列表'
				},
			}
		]
	},
	{
		path: '/restaurant', 
		component: MainVue,
		meta: { 
			requiresAuth: true,
			title:'餐厅管理'
		},
		children: [
		    {
		        path: 'restaurant-add',
		        component: RestaurantInfoAddVue,
				meta: { 
					requiresAuth: true ,
					title:'新增餐厅'
				},
		    },
			{
			    path: 'restaurant-list',
			    component: RestaurantInfoListVue,
				meta: { 
					requiresAuth: true ,
					title:'餐厅列表'
				},
			}
		]
	},
	{
		path: '/doctor', 
		component: MainVue,
		meta: { 
			requiresAuth: true,
			title:'医师管理'
		},
		children: [
		    {
		        path: 'doctor-add',
		        component: DoctorInfoAddVue,
				meta: { 
					requiresAuth: true ,
					title:'新增医师'
				},
		    },
			{
			    path: 'doctor-list',
			    component: DoctorInfoListVue,
				meta: { 
					requiresAuth: true ,
					title:'医师列表'
				},
			}
		]
	},
	{
		path: '/news', 
		component: MainVue,
		meta: { 
			requiresAuth: true,
			title:'资讯管理'
		},
		children: [
		    {
		        path: 'news-add',
		        component: NewsInfoAddVue,
				meta: { 
					requiresAuth: true ,
					title:'新增资讯'
				},
		    },
			{
			    path: 'news-list',
			    component: NewsInfoListVue,
				meta: { 
					requiresAuth: true ,
					title:'资讯列表'
				},
			}
		]
	},{
		path: '/dictionary', 
		component: MainVue,
		meta: { 
			requiresAuth: true,
			title:'医疗词典'
		},
		children: [
		    {
		        path: 'dictionary-add',
		        component: DictionaryAddVue,
				meta: { 
					requiresAuth: true ,
					title:'新增词典'
				},
		    },
			{
			    path: 'dictionary-list',
			    component: DictionaryListVue,
				meta: { 
					requiresAuth: true ,
					title:'词典列表'
				},
			}
		]
	},
	{
		path: '/comment', 
		component: MainVue,
		meta: { 
			requiresAuth: true,
			title:'评论注解'
		},
		children: [
			{
			    path: 'comment-list',
			    component: CommentInfoListVue,
				meta: { 
					requiresAuth: true ,
					title:'评论列表'
				},
			}
		]
	}
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

router.beforeEach(async(to, from, next) => {
  const userStore = useMemberStore();
  document.title = to.meta.title || '敖途旅行';
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // 判断用户是否已登录
    if (userStore.profile?.token) {
		if(!userStore.profile?.token){
			next("/login");
		}else{
			const res = await axios.post('/api/check', {
			  userid: userStore.profile.userid,
			  token: userStore.profile.token,
			}, {
			  headers: {
			    'Content-Type': 'application/json'
			  }
			});
			if(res.data.status===0){
				if(res.token!==undefined){
					userStore.setProfile({
						mobile: userStore.profile.mobile,
						token: res.data.token,
						userid: userStore.profile.userid,
						name: userStore.profile.name,
					});
				}
				// 已登录，则跳转到目标路由（需要用户登录的页面）
				next();
			}else{
				//登录过期
				next("/login");
			}
		}
    } else {
		// 未登录，跳转到登录页
		next("/login");
    }
  } else {
		// 公共页面，直接跳转到目标路由
		next();
  }
});
export default router;
